module.exports = __webpack_public_path__ + "img/Kaiser.2c7fc7c1.jpeg";